export type DPI = 203 | 300

export const DPI_OPTIONS: DPI[] = [203, 300]

export function mmToDots(mm: number, dpi: DPI): number {
  const dotsPerMm = dpi / 25.4
  return Math.round(mm * dotsPerMm)
}

export function dotsToMm(dots: number, dpi: DPI): number {
  const dotsPerMm = dpi / 25.4
  return dots / dotsPerMm
}

export function getDotsPerMm(dpi: DPI): number {
  return dpi / 25.4
}
